import {
  DEFAULT_CALL_ELIGIBILITY,
  type CallEligibilityConfig,
} from '@shared/calls/call-eligibility'

/**
 * Runtime status-aware-calling config. Defaults to the shared gate model; ops can
 * relax the gate (warn instead of block) for everything via env without a code
 * change while the feature beds in.
 */
export function getCallEligibilityConfig(): CallEligibilityConfig {
  const mode = import.meta.env.VITE_CALL_STATUS_GATE_MODE?.trim().toLowerCase()
  if (mode === 'off') {
    return {
      gates: {
        targetOffline: 'allow',
        targetIdle: 'allow',
        targetPauseNotifications: 'allow',
        targetOnActiveCall: 'allow',
        targetCalendarUnavailable: 'allow',
        activityPreset: {},
      },
    }
  }
  if (mode === 'warn-only') {
    return {
      gates: {
        targetOffline: 'warn',
        targetIdle: 'warn',
        targetPauseNotifications: 'warn',
        targetOnActiveCall: 'warn',
        targetCalendarUnavailable: 'warn',
        activityPreset: {
          'out-sick': 'warn',
          vacation: 'warn',
          'in-meeting': 'warn',
          'focus-time': 'warn',
          commuting: 'warn',
          'working-remotely': 'allow',
        },
      },
    }
  }
  return DEFAULT_CALL_ELIGIBILITY
}
